export default __webpack_public_path__ + "static/media/Mystic's Helm of the Soaring God.b9f44cf8.jpg";